import _Login from '../ui/login/Login';

const Login = () => {
    return (
        <_Login />
    )
};

export default Login;